module.exports = __webpack_public_path__ + "static/media/motogama.7635bf23.png";